<template>
  <div class="vs-row">
    <vs-col vs-lg="12" vs-xs="12">
      <vs-card class="cardx">
        <div class="vs-row">
          <vs-col vs-lg="12" vs-xs="12">
            <iframe
              class="w-full height-350 border-0"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3105.457742418827!2d-77.00662848481065!3d38.89064655494741!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b7b828d32c69bb%3A0xffb704728ee19592!2sSupreme%20Court%20of%20the%20United%20States!5e0!3m2!1sen!2sin!4v1575976537424!5m2!1sen!2sin"
              allowfullscreen=""
            ></iframe>
          </vs-col>
        </div>
      </vs-card>
    </vs-col>

    <vs-col vs-lg="6" vs-xs="12">
      <div class="con-vs-card cardx overflow-hidden">
        <header class="vs-card--header">
          <div>
            <h6 class="font-medium">Feedback</h6>
          </div>
        </header>
        <div class="vs-card--content">
          <vs-input
            label=""
            class="w-full mb-3"
            
            placeholder="Name"
          />
          <vs-input
            label=""
            class="w-full mb-3"
            
            placeholder="Email"
          />
          <vs-textarea class="mb-3" label="Message"  />
          <vs-button> Submit </vs-button>
        </div>
      </div>
    </vs-col>
    <vs-col vs-lg="6" vs-xs="12">
      <div class="con-vs-card cardx overflow-hidden">
        <header class="vs-card--header">
          <div>
            <h6 class="font-medium">Contact us</h6>
          </div>
        </header>
        <div class="vs-card--content">
          <address>
            <strong>Loop, Inc.</strong><br />
            795 Park Ave, Suite 120<br />
            San Francisco, CA 94107<br />
            <abbr title="Phone">P: </abbr> (234) 145-1810
          </address>
          <address class="mt-3">
            <strong>Email</strong><br />
            <a href="mailto:#" class="redial-primary redial-font-weight-600"
              >first.last@email.com
            </a>
          </address>
          <div class="text-left">
            <a href="#" class="btn btn-social btn-dropbox text-white mb-2">
              <i class="ion ion-social-dropbox"></i>
            </a>
            <a href="#" class="btn btn-social btn-facebook text-white mb-2">
              <i class="ion ion-social-facebook"></i>
            </a>
            <a href="#" class="btn btn-social btn-github text-white mb-2">
              <i class="ion ion-social-github"></i>
            </a>
            <a href="#" class="btn btn-social btn-google text-white mb-2">
              <i class="ion ion-social-google"></i>
            </a>
            <a href="#" class="btn btn-social btn-instagram text-white mb-2">
              <i class="ion ion-social-instagram"></i>
            </a>
            <a href="#" class="btn btn-social btn-linkedin text-white mb-2">
              <i class="ion ion-social-linkedin"></i>
            </a>
            <a href="#" class="btn btn-social btn-pinterest text-white mb-2">
              <i class="ion ion-social-pinterest"></i>
            </a>
            <a href="#" class="btn btn-social btn-tumblr text-white mb-2">
              <i class="ion ion-social-tumblr"></i>
            </a>
            <a href="#" class="btn btn-social btn-twitter text-white mb-2">
              <i class="ion ion-social-twitter"></i>
            </a>
          </div>
        </div>
      </div>
    </vs-col>
  </div>
</template>
<script>
export default {
  watch: {
    "$store.state.theme"(val) {
      this.chartTheme(val);
    },
  },
  methods: {
    chartTheme(val) {
      let mode = val == "dark" ? "dark" : "light";
        return mode;
    },
  },
  mounted() {
    this.chartTheme(this.$store.state.theme);
  },
  data: function () {
    return {};
  },
};
</script>